import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import Img from "gatsby-image"

const EventPreview = ({ title, slug, image, excerpt, eventDate, eventTime, eventLocation }) => (
  <div className="row mt-2">
    <div className="col-md">
      <Link to={slug}>
        <h2>{title}</h2>
      </Link>
      <p className="font-weight-bolder">On {eventDate} at {eventTime} at {eventLocation}</p>
      <p>{excerpt}</p>
    </div>
    <div className="col-md">
      <Link to={slug}>
        <Img sizes={image} />
      </Link>
    </div>
  </div>
)

EventPreview.propTypes = {
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  excerpt: PropTypes.string.isRequired,
  eventDate: PropTypes.string.isRequired,
  eventTime: PropTypes.string.isRequired,
  eventLocation: PropTypes.string.isRequired,
}

export default EventPreview